/* Joii Employee Benefits Features: connected steps with a picture that swaps.
   Desktop: the section holds still (CSS sticky) while scrolling selects each step in turn; clicking scrolls to a step.
   Phones, or if the theme stops sticky from working: steps are selected by click, and highlighted as they scroll into view. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(scroller) {
    if (scroller.dataset.jbReady) return;
    scroller.dataset.jbReady = '1';
    var steps = Array.prototype.slice.call(scroller.querySelectorAll('[data-jb-step]'));
    var pics = Array.prototype.slice.call(scroller.querySelectorAll('[data-jb-pic]'));
    var sticky = scroller.querySelector('.jb-feat__sticky');
    var current = 0;

    function select(i) {
      current = i;
      steps.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        s.classList.toggle('is-done', n < i);
        s.querySelector('.jb-feat__tab').setAttribute('aria-current', n === i ? 'step' : 'false');
      });
      pics.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
    }

    function scrollMode() {
      return DESKTOP.matches && !scroller.classList.contains('jb-feat--static') && steps.length > 1;
    }

    // how far through the tall scroller we are, 0..1
    function stickTop() { return parseFloat(getComputedStyle(sticky).top) || 0; }
    function range() { return scroller.offsetHeight - sticky.offsetHeight; }
    function progress() {
      var r = scroller.getBoundingClientRect();
      if (range() <= 0) return 0;
      return Math.min(1, Math.max(0, (stickTop() - r.top) / range()));
    }

    var ticking = false;
    function onScroll() {
      if (ticking || !scrollMode()) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.min(steps.length - 1, Math.floor(progress() * steps.length));
        if (i !== current) select(i);
        checkSticky();
      });
    }

    // Some themes break position: sticky (overflow on a parent). If the panel isn't holding still, fall back to click-only.
    function checkSticky() {
      var r = scroller.getBoundingClientRect();
      var inRange = r.top < -40 && r.bottom > window.innerHeight + 40;
      if (!inRange) return;
      var expected = stickTop();
      if (Math.abs(sticky.getBoundingClientRect().top - expected) > 24) {
        scroller.classList.add('jb-feat--static');
      }
    }

    steps.forEach(function (step, i) {
      step.querySelector('.jb-feat__tab').addEventListener('click', function () {
        if (scrollMode()) {
          var r = scroller.getBoundingClientRect();
          var top = window.scrollY + r.top - stickTop() + range() * ((i + 0.5) / steps.length);
          window.scrollTo({ top: top, behavior: REDUCED.matches ? 'auto' : 'smooth' });
        }
        select(i);
      });
    });

    // Phones: highlight the step nearest the middle of the screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (scrollMode()) return;
        entries.forEach(function (e) {
          if (e.isIntersecting) select(steps.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    }

    // Theme editor: selecting a step block shows it
    scroller.addEventListener('shopify:block:select', function (e) {
      var s = e.target.closest('[data-jb-step]');
      if (s) select(steps.indexOf(s));
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-jb-features]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
